"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = exports.ButtonText = exports.Note = exports.ButtonWrapper = exports.BottomCTA = exports.FeaturesWrapper = exports.TestimonialsWrapper = exports.Content = exports.Hero = exports.Headline = exports.BigButton = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const elements_1 = require("@src/components/elements");
const mux_video_react_1 = __importDefault(require("@mux/mux-video-react"));
exports.Wrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;
exports.BigButton = (0, styled_components_1.default)(elements_1.Button) `
	${(0, styled_breakpoints_1.up)('sm')} {
		transform: scale(1.2);
	}
`;
exports.Headline = styled_components_1.default.div `
	position: relative;
	z-index: 1;
	text-align: center;
	padding: 3.5em 2em 0;

	${(0, styled_breakpoints_1.up)('sm')} {
		padding: 2.5em 2em 0;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		padding: 5em 2em 0;
	}

	& > * {
		color: ${props => props.theme.color.white};
	}
	h1 {
		font-size: 2.4em;
		font-weight: bold;
		margin-bottom: 0.5em;
	}
	h2 {
		font-size: 1.4em;
		font-weight: 200;
		line-height: 1.4;
	}
`;
exports.Hero = styled_components_1.default.div `
	padding-top: ${props => props.theme.size.headerHeight}px;
	width: 100%;
	height: 360px;
	position: relative;
	background: url('/media/images/hero-candidate.jpg');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center 0;

	&:after {
		content: '';
		display: block;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		position: absolute;
		z-index: 0;
		pointer-events: none;
		opacity: 0.95;
		background: url('/media/images/background-gradient.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		transform: scaleX(-1);
	}
`;
exports.Content = styled_components_1.default.div `
	width: 100%;
`;
exports.TestimonialsWrapper = styled_components_1.default.div `
	width: 100%;

	padding: 5em 0;

	h2 {
		color: ${props => props.theme.color.brand4};
		font-size: 2em;
		text-align: center;
		font-weight: 700;
		margin: 0 0 2em;
	}
`;
exports.FeaturesWrapper = styled_components_1.default.div `
	width: 100%;
	background: ${props => props.theme.color.white};
	padding: 5em 0 5em;
	text-align: center;
	border-bottom: 1px solid ${props => props.theme.color.gray2};

	h2 {
		color: ${props => props.theme.color.brand4};
		font-size: 2em;
		text-align: center;
		font-weight: 700;
		margin: 0 0 2em;
	}
`;
exports.BottomCTA = styled_components_1.default.div `
	width: 100%;
	background: ${props => props.theme.color.white};
	padding: 5em 0;
	text-align: center;

	p strong {
		color: ${props => props.theme.color.brand2};
	}

	h2 {
		color: ${props => props.theme.color.brand4};
		font-size: 2em;
		font-weight: 700;
		margin: 0 0 0.5em;
	}
`;
exports.ButtonWrapper = styled_components_1.default.div `
	width: 100%;
	text-align: center;
`;
exports.Note = styled_components_1.default.div `
	width: 100%;
	font-weight: 400;
	font-size: 0.9em;
	padding: 1em 3em 0;
	color: ${props => props.theme.color.gray6};
`;
exports.ButtonText = styled_components_1.default.div ``;
exports.Video = (0, styled_components_1.default)(mux_video_react_1.default) `
	height: 100%;
	max-width: 100%;
	width: 50em;
	border-radius: 0.8rem;
	margin-bottom: 6em;
`;
